import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-error text-center my-4"
}

import { ArticleListItem } from '@/services/news/article.model';
import { deleteArticle, getAllArticles } from '@/services/news/article.service';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'ManageArticle',
  setup(__props) {

const articles = ref<ArticleListItem[]>([]);
const loading = ref(true);
const error = ref<string | null>(null);
const router = useRouter();

const dialog = ref(false);
const selectedArticle = ref<ArticleListItem | null>(null);

async function loadArticles() {
  loading.value = true;
  error.value = null;

  try {
    articles.value = await getAllArticles();
  } catch (err: any) {
    console.error(err);
    error.value = err?.message || 'Failed to load articles.';
  } finally {
    loading.value = false;
  }
}

function openDeleteDialog(article: ArticleListItem) {
  selectedArticle.value = article;
  dialog.value = true;
}

async function confirmDelete() {
  if (!selectedArticle.value) return;

  try {
    await deleteArticle(selectedArticle.value.id);
    dialog.value = false;
    selectedArticle.value = null;
    await loadArticles();
  } catch (err: any) {
    console.error(err);
    error.value = err?.message || 'Failed to delete article.';
    dialog.value = false;
  }
}

function cancelDelete() {
  selectedArticle.value = null;
  dialog.value = false;
}

function openEditPage(id: number) {
  router.push({ name: 'cms-edit-article', params: { id } });
}

onMounted(loadArticles);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "fill-height d-flex align-center justify-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        "max-width": "600",
        class: "w-100 pa-7"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5 text-center mb-4" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Manage Articles", -1)
            ]))]),
            _: 1
          }),
          (loading.value)
            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                key: 0,
                indeterminate: "",
                color: "primary",
                class: "d-flex mx-auto my-6"
              }))
            : (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(error.value), 1))
              : (_openBlock(), _createBlock(_component_v_list, { key: 2 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articles.value, (article) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: article.id,
                        class: "hover:bg-grey-lighten-4 rounded-lg my-1"
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            icon: "",
                            variant: "text",
                            color: "primary",
                            onClick: ($event: any) => (openEditPage(article.id))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                  _createTextVNode("mdi-pencil", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            icon: "",
                            variant: "text",
                            color: "error",
                            onClick: ($event: any) => (openDeleteDialog(article))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                  _createTextVNode("mdi-delete", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(article.title), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }))
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: dialog.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
        "max-width": "400"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createTextVNode(" Are you sure you want to permanently delete ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(selectedArticle.value?.title), 1),
                  _cache[5] || (_cache[5] = _createTextVNode("? ", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    text: "",
                    color: "grey",
                    onClick: cancelDelete
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("Cancel", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "error",
                    onClick: confirmDelete
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("OK", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})